import { maxBy, minBy, toInteger } from 'lodash';
import { getFramework } from '@/framework';
import { base64Kit } from '@/utils/base64-kit';
import { createCanvas, drawLayerBaseInfoAsync, loadImageAsync } from '@/utils/file-kit';
import { rotatePointWithFocus } from '@/utils/math-kit';
import { IImageLayerProps, ILayerProps, IPoint, ISize } from '@/version-types';

export const renderLayerToStage = async (
    identity: string,
    layer: ILayerProps,
    domCanvas: HTMLCanvasElement,
    stageSize?: ISize,
): Promise<HTMLCanvasElement> => {
    const { width, height, left, top, opacity, rotate } = layer;
    const {
        url,
        imageTransform: { flipH, flipV, scale },
        naturalHeight,
        naturalWidth,
    } = layer.data as IImageLayerProps;
    const originImgWidth = toInteger(naturalWidth);
    const originImgHeight = toInteger(naturalHeight);
    const scaleWidth = toInteger(originImgWidth * scale);
    const scaleHeight = toInteger(originImgHeight * scale);
    const resultWidth = toInteger(width);
    const resultHeight = toInteger(height);
    const centerPoint = {
        x: scaleWidth / 2 + left,
        y: scaleHeight / 2 + top,
    };

    // 等待上传完成
    await base64Kit.getRemoteUrlAsync(url);
    // 设置绘制的真正元素
    let img: HTMLCanvasElement | HTMLImageElement = domCanvas;
    if (!domCanvas || domCanvas?.getAttribute('ready') === 'false') {
        try {
            img = await loadImageAsync(url, true);
        } catch (e) {
            const framework = getFramework(identity);

            framework.events.emitBehaviorErrorImage({ layerId: layer.id, imageUrl: url });

            return createCanvas(1, 1).canvas;
        }
    }

    // 绘制图层翻转、透明度
    const { canvas: baseCanvas, ctx: baseCtx } = await drawLayerBaseInfoAsync(
        originImgWidth,
        originImgHeight,
        flipH,
        flipV,
        opacity,
    );
    baseCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, originImgWidth, originImgHeight);
    // 图片缩放
    const { canvas: scaleCanvas, ctx: scaleCtx } = createCanvas(scaleWidth, scaleHeight);
    scaleCtx.drawImage(baseCanvas, 0, 0, originImgWidth, originImgHeight, 0, 0, scaleWidth, scaleHeight);
    // const basePoint = {
    //     x: scaleWidth / 2,
    //     y: scaleHeight / 2,
    // };
    // const positions = [
    //     rotatePointWithFocus({ x: 0, y: 0 }, basePoint, rotate),
    //     rotatePointWithFocus({ x: scaleWidth, y: 0 }, basePoint, rotate),
    //     rotatePointWithFocus({ x: 0, y: scaleHeight }, basePoint, rotate),
    //     rotatePointWithFocus({ x: scaleWidth, y: scaleHeight }, basePoint, rotate),
    // ];
    // const minX = minBy(positions, (pos) => pos.x) as IPoint;
    // const maxX = maxBy(positions, (pos) => pos.x) as IPoint;
    // const minY = minBy(positions, (pos) => pos.y) as IPoint;
    // const maxY = maxBy(positions, (pos) => pos.y) as IPoint;
    // const newWidth = toInteger(maxX.x - minX.x);
    // const newHeight = toInteger(maxY.y - minY.y);
    // const { canvas: transformCanvas, ctx: transformCtx } = createCanvas(newWidth, newHeight);
    // transformCtx.translate(centerPoint.x, centerPoint.y);
    // transformCtx.rotate((Math.PI / 180) * rotate);
    // transformCtx.drawImage(
    //     scaleCanvas,
    //     0,
    //     0,
    //     scaleWidth,
    //     scaleHeight,
    //     -scaleWidth / 2,
    //     -scaleHeight / 2,
    //     scaleWidth,
    //     scaleHeight,
    // );
    // 转换，图片 -> 图层，结果图
    const { canvas: resultCanvas, ctx: resultCtx } = createCanvas(resultWidth, resultHeight);
    resultCtx.translate(centerPoint.x, centerPoint.y);
    resultCtx.rotate((Math.PI / 180) * rotate);
    resultCtx.drawImage(
        scaleCanvas,
        0,
        0,
        scaleWidth,
        scaleHeight,
        -scaleWidth / 2,
        -scaleHeight / 2,
        scaleWidth,
        scaleHeight,
    );

    // HACK: safari16.6 下，drawImage 的 srcWidth 和 srcHeight 不能超过 srcImage 的 width 和 height，否则绘制会空白
    // const sourceWidth = Math.min(transformCanvas.width, resultWidth);
    // const sourceHeight = Math.min(transformCanvas.height, resultHeight);
    // resultCtx.drawImage(
    //     transformCanvas,
    //     0,
    //     0,
    //     transformCanvas.width,
    //     transformCanvas.height,
    //     0,
    //     0,
    //     resultWidth,
    //     resultHeight,
    // );
    return resultCanvas;
};
